var HOC_API_RESPONSE = 'growth_non_int_HOC_API_RESPONSE';

// TODO: break this object to seperate variables. TREE SHAKING!!!
var BANNER_TYPE = {
  TOP_BANNER_CAROUSAL: 'topbannercarousal',
  TOP_BANNER: 'topbanner',
  TOP_BANNER_RATING: 'topbannerRating',
  BOTTOM_SHEET: 'bottomsheet',
  APP_DIALOG: 'appdialog',
  DESKTOP_DRAWER: 'desktopdrawer',
  DESKTOP_POPUP: 'dwebpip',
  INLINE_CARD: 'inlinecard',
  FULL_PAGE: 'fullpagesheet',
  MWEB_RECENT_SEARCH_CARD: 'mwebrecentsearchcard',
  BOTTOM_BAR: 'bottombar',
  INLINE_CARD_DESKTOP: 'inlinecarddesktop',
  FLOATING_BTN: 'floatingbtn'
};
var DWEB_RECENT_SEARCH_CARD = 'dwebrecentsearchcard';

var CTA_TYPE = {
  PLAYSTORE: 'playstore',
  APPSTORE: 'appstore',
  QR_CODE: 'qrcode'
};
var hideTopBannerEventName = 'hideTopBanner';
var showTopBannerEventName = 'showTopBanner';
var triggerLoadEventName = 'bannerLoad';
var APP_BANNER_CONFIG_STORE_TAGS = 'MWEB_2_APP_BANNER';

export { APP_BANNER_CONFIG_STORE_TAGS as A, BANNER_TYPE as B, CTA_TYPE as C, DWEB_RECENT_SEARCH_CARD as D, HOC_API_RESPONSE as H, hideTopBannerEventName as h, showTopBannerEventName as s, triggerLoadEventName as t };
